/* eslint-disable react/prop-types */
import React from "react"
import { Redirect } from "react-router"
import { useParams } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import { branch, compose, renderComponent, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import moment from "moment"
import { archiveCaseMutation } from "../../apollo/mutations"
import { CASE_DETAIL_QUERY } from "../../apollo/queries"
import routes from "../../routes"
import PatientCaseSummary from "./"

const OpenCaseRedirect = (props) => (
  <Redirect
    to={formatRoute(routes.openCases, {
      facilityId: props.facilityId,
    })}
    push={true}
  />
)

const ArchivedCaseRedirect = (props) => (
  <Redirect
    to={formatRoute(routes.archivedCases, {
      facilityId: props.facilityId,
    })}
    push={true}
  />
)

const PatientCaseSummaryEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(CASE_DETAIL_QUERY, {
    options: ({ facilityId, caseId }) => ({
      variables: { facilityId, caseId },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const kase = facility.contactTracingCases[0]

      return {
        archivedAt: kase.archivedAt,
        subjects: kase.subjects.map((subject) => ({
          entityId: subject.entity.id,
          entityName: subject.entity.name,
          startAt: moment.parseZone(subject.startAt),
          endAt: moment.parseZone(subject.endAt),
          visits: subject.entity.contactTracingVisits.totalCount,
        })),
        id: kase.id,
      }
    },
  }),
  archiveCaseMutation,
  branch(
    ({ archiveData }) =>
      archiveData && archiveData.putContactTracingCase.archivedAt !== null,
    renderComponent(OpenCaseRedirect)
  ),
  branch(
    ({ archiveData }) =>
      archiveData && archiveData.putContactTracingCase.archivedAt === null,
    renderComponent(ArchivedCaseRedirect)
  )
)(PatientCaseSummary)

export default PatientCaseSummaryEnhanced
